module.exports = __webpack_public_path__ + "media/img/corporate/ad-banners-088f8ca0ddc84460ae417775d4cc8818.png";